import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('dasavena_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('dasavena_token');
      localStorage.removeItem('dasavena_usuario');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authService = {
  login:           (email, password) => api.post('/api/auth/login', { email, password }),
  me:              ()                => api.get('/api/auth/me'),
  usuarios:        ()                => api.get('/api/auth/usuarios'),
  modulos:         ()                => api.get('/api/auth/modulos'),
  departamentos:   ()                => api.get('/api/auth/departamentos'),
  crearUsuario:    (data)            => api.post('/api/auth/usuarios', data),
  actualizarUsuario: (id, data)      => api.patch(`/api/auth/usuarios/${id}`, data),
};

export const bomService = {
  getAll:    (search = '') => api.get(`/api/bom${search ? `?search=${search}` : ''}`),
  getById:   (id)          => api.get(`/api/bom/${id}`),
  syncManual: ()           => api.post('/api/bom/sync/manual'),
  updateComponentes: (id, componentes) => api.patch(`/api/bom/${id}/componentes`, { componentes }),
};

export const kpiService = {
  overview:                ()       => api.get('/api/kpis/overview'),
  sync:                    (key)    => api.post(`/api/kpis/sync/${key}`),
  disponibilidadMPResumen: ()       => api.get('/api/kpis/disponibilidad-mp/resumen'),
  disponibilidadMPDetalle: (params) => api.get('/api/kpis/disponibilidad-mp/detalle', { params }),
  preciosMPResumen:        ()       => api.get('/api/kpis/precios-mp/resumen'),
  preciosMPDetalle:        (params) => api.get('/api/kpis/precios-mp/detalle', { params }),
  diasOCResumen:           ()       => api.get('/api/kpis/dias-colocacion-oc/resumen'),
  diasOCDetalle:           (params) => api.get('/api/kpis/dias-colocacion-oc/detalle', { params }),
  diasOCGuardarComentario: (numeroDocumento, comentario) =>
    api.patch(`/api/kpis/dias-colocacion-oc/${numeroDocumento}/comentario`, { comentario }),
  otifResumen:             (params) => api.get('/api/kpis/otif/resumen', { params }),
  otifPorProveedor:        (params) => api.get('/api/kpis/otif/por-proveedor', { params }),
  otifDetalle:             (params) => api.get('/api/kpis/otif/detalle', { params }),
};

export const logisticaService = {
  conversionCajas:          ()          => api.get('/api/logistica/conversion-cajas'),
  guardarConversionCaja:    (upc, data) => api.put(`/api/logistica/conversion-cajas/${upc}`, data),
  };

export default api;